/**
 * Common function that builders should use to render linked question. Necessary to ensure that the validation reducer runs for
 * linked questions once a builder question is changed
 *
 * @param {Object} linkedQuestion: QuestionShape object to be rendered in the builder
 * @param {Function} linkedQuestionValueChanged: decorator function that runs after value has changed for the Question
 * @param {Function} renderQuestion: function that renders the linkedQuestion. Typically comes from QuestionGroupContainer.jsx
 * @returns {*}
 */

const builderRenderLinkedQuestion = (linkedQuestion, linkedQuestionValueChanged, renderQuestion) => {
  const onLinkedQuestionValueChange = ({value, valueChanged}) => {
    valueChanged(value);
    linkedQuestionValueChanged(linkedQuestion);
  };

  return renderQuestion({
    ...linkedQuestion,
    attributes: {
      ...(linkedQuestion.attributes || {}),
      valueChanged: onLinkedQuestionValueChange
    }
  });
};

export {
  builderRenderLinkedQuestion as default,
};
